export function Reducer(state, action) {
  switch (action.type) {
    case "load":
      return {
        ...state,
        policy: action.policy,
        viewMode: action.policy == null ? "load" : "view",
      };
    case "createPolicy":
      return {
        ...state,
        policy: action.policy,
      };
    case "updatePolicy":
      return {
        ...state,
        policy: action.policy,
      };
    case "setViewMode":
      return {
        ...state,
        viewMode: action.viewMode,
      };
    default:
      throw new Error();
  }
}
